import { motion } from "framer-motion";
import { MessageCircle, Instagram } from "lucide-react";
import { WA_MAIN, INSTAGRAM_URL } from "@/lib/api";

export const Nav = () => {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-40 bg-cream/80 backdrop-blur-md border-b border-wood/10"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#topo" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img src="/logo.png" alt="Cestou Recordações" className="h-11 w-auto" data-testid="nav-logo" />
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-wood/80">
          <a href="#topo" className="hover:text-brand transition-colors" data-testid="nav-link-inicio">Início</a>
          <a href="#catalogo" className="hover:text-brand transition-colors" data-testid="nav-link-catalogo">Catálogo</a>
          <a href="#como-funciona" className="hover:text-brand transition-colors" data-testid="nav-link-como-funciona">Como funciona</a>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-instagram-link"
            aria-label="Instagram @cestourecordacoes"
            className="w-9 h-9 rounded-full bg-white border border-wood/10 shadow-sm flex items-center justify-center text-wood/70 hover:text-brand hover:border-brand/40 transition-colors"
          >
            <Instagram className="w-[18px] h-[18px]" />
          </a>
          <a
            href={WA_MAIN}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb857] text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors shadow-sm"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden sm:inline">(51) 98997-5814</span>
            <span className="sm:hidden">WhatsApp</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
};
